import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import complement from 'ramda/es/complement';
import find from 'ramda/es/find';
import equals from 'ramda/es/equals';

import { Container, Dropdown, Icon, Label, Language, Link, ToggleButton } from './languageDropdown.styles';
import { extract, getField, getFieldIn, getImgProps } from '../../utils/cmsData';
import messages from './languageDropdown.messages';
import { ariaLiveHandler } from '../../utils/accessibility';

export class LanguageDropdown extends PureComponent {
  static propTypes = {
    languages: PropTypes.object,
    fetchLanguages: PropTypes.func,
    currentLanguage: PropTypes.string,
    intl: PropTypes.object.isRequired,
  };

  state = {
    isOpen: false,
  };

  componentDidMount() {
    if (!this.props.languages.size) {
      this.props.fetchLanguages();
    }
  }

  getLanguageFields = extract({
    url: getFieldIn(['url', 'url']),
    label: getField('label'),
    icon: getField('icon'),
  });

  get currentLanguage() {
    return find((language) => getField('id', language) === this.props.currentLanguage)(this.props.languages);
  }

  get languages() {
    return this.props.languages.filter(complement(equals(this.currentLanguage))).map(this.getLanguageFields);
  }

  openDropdown = () => this.setState({ isOpen: true });

  closeDropdown = () => this.setState({ isOpen: false });

  toggleDropdown = () => this.setState(prevState => ({ isOpen: !prevState.isOpen }));

  renderDropdown = () => {
    return (
      <Dropdown isVisible={this.state.isOpen}>
        {this.languages.map(({ icon, label, url }, index) => (
          <Language key={index}>
            <Link url={url} newTab={false}>
              <Icon image={getImgProps(icon).src} />
              <Label>{label}</Label>
            </Link>
          </Language>
        ))}
      </Dropdown>
    );
  };

  render() {
    return (
      <Container
        onMouseEnter={this.openDropdown}
        onMouseLeave={this.closeDropdown}
      >
        <ToggleButton
          aria-label={this.props.intl.formatMessage(messages.label)}
          aria-expanded={this.state.isOpen}
          onClick={this.toggleDropdown}
          aria-live={ariaLiveHandler()}
        >
          <Icon image={getImgProps(getField('icon', this.currentLanguage)).src} />
        </ToggleButton>

        {this.renderDropdown()}
      </Container>
    );
  }
}
